import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { StockCountSandbox } from 'app/core/sandboxes/stock-count.sandbox';
import { Definition } from 'app/core/store/definitions/definition.interface';
import { Definitions } from 'app/core/store/definitions/definitions.interface';
import { SCMaterial } from 'app/core/store/stock-count/stock-count.interface';

@Component({
  selector: 'stock-count-material-list',
  templateUrl: './stock-count-material-list.component.html',
  styleUrls: ['../../../florders/florder-list/florder-list.scss', './stock-count-material-list.component.scss'],
})
export class StockCountMaterialListComponent implements OnChanges {
  allCounted: boolean = false;
  countedMaterials: SCMaterial[] = [];
  sandbox: StockCountSandbox;
  comment: string = '';

  @Input() materials: SCMaterial[] = null;
  @Input() shipTos: Definition[];
  @Input() definitions: Definitions;

  @Output() getCreateStockCount: EventEmitter<{ materialList: SCMaterial[]; comment: string }> = new EventEmitter();

  constructor(sandbox: StockCountSandbox, private translateService: TranslateService) {
    this.sandbox = sandbox;
  }

  columns = [
    {
      id: 'packingID',
      colName: this.translateService.instant('STOCK_COUNT.HEADERS.MATERIAL'),
    },
    {
      id: 'amount',
      colName: this.translateService.instant('STOCK_COUNT.HEADERS.STOCK_LEVELS'),
    },
    {
      id: 'countResults',
      colName: this.translateService.instant('STOCK_COUNT.HEADERS.COUNT'),
    },
    {
      id: 'notCounted',
      colName: this.translateService.instant('STOCK_COUNT.HEADERS.NOT_COUNTED'),
    },
  ];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.materials && changes.materials.currentValue && changes.materials.currentValue.length > 0) {
      this.materials.map(m => this.countedMaterials.push(m));
    }
  }

  addCountedMaterial(material: SCMaterial) {
    if (!this.checkIfExists(material)) {
      this.countedMaterials.push(material);
    }
  }

  removeCountedMaterial(material: SCMaterial) {
    const index = this.countedMaterials.findIndex(m => {
      return m.packingID === material.packingID;
    });
    if (index > -1) {
      // remove element
      this.countedMaterials.splice(index, 1);
    }
  }

  updateCountedMaterial(material: SCMaterial) {
    this.removeCountedMaterial(material);
    this.addCountedMaterial(material);
    this.isListValid();
  }

  checkIfExists(material: SCMaterial): boolean {
    // find index
    const index = this.countedMaterials.findIndex(m => {
      return m.packingID === material.packingID;
    });
    return index > -1;
  }

  isListValid() {
    let validList: boolean = true;
    this.countedMaterials.map(m => {
      if (!m.isValid) {
        validList = false;
      }
    });
    this.allCounted = validList;
  }

  materialValid(id: string): boolean {
    let valid = false;
    this.countedMaterials.map(m => {
      if (m.packingID === id) {
        valid = m.isValid;
      }
    });
    return valid;
  }

  createStockCount() {
    if (this.allCounted) {
      this.getCreateStockCount.emit({
        materialList: this.countedMaterials,
        comment: this.comment,
      });
    }
  }

  cancelClicked() {
    this.sandbox.cancelCreate();
  }
}
